import { SessionContextType } from '../contexts/SessionContext';
import { isYaxleInternalAdmin } from './yaxleAdminAccess';

/**
 * The Integrations section in organization settings is Yaxle-internal only:
 * it exposes stored provider credentials, so only internal admins (admin
 * employee accounts or company-domain admins, the same `user.admin` the API
 * requires) may see or manage it. Gates both the Settings sidebar entry and
 * the rendered section.
 */
export const canAccessIntegrations = (sessionContext: SessionContextType | undefined): boolean =>
    isYaxleInternalAdmin(sessionContext);
